import {NEW_FLOORPLAN, NEW_DATASET} from '../utils/constants';
import {initialState} from '../reducers'


const floorplanReducer = (prevState, action) => {
  //console.log('#RDC-metadata', '++:', prevState, '&&:', action);
  switch (action.type) {
    case NEW_FLOORPLAN:
      return action.payload
    case NEW_DATASET:
    if (action.payload.floorplan) {
      return action.payload.floorplan
    }
    default:
    if (prevState) {
      return prevState}
    else {return initialState.floorplan}

  }

  //console.log(action.payload);


}

export default floorplanReducer



// WEBPACK FOOTER //
// ./src/reducers/reducer-floorplanReducer.js